// @flow
import React from 'react';
import _ from 'lodash';
import I18n from '../../../i18n/I18n';
import Helper from '../../../helper/Helper';
import { ProductNameBox } from '../../common/';
import styles from '../../orders/orderTable/orderBox/OrderBox.scss';

const StockBox = (props: Object) => {
    const { item, searchString } = props;
    const itemProp = item.items ? Helper.validator(item.items) : '';
    const itemLevel = oneItem => (
        <div className={styles.itemCtr}>
            <div className={styles.flexer}>
                {oneItem.title ? (
                    <a
                        target="_blank"
                        href={`${Helper.getAppDomain(
                            'catalog',
                        )}/${Helper.getLocale()}/catalog/${
                            item.psku_canonical
                        }`}
                    >
                        <ProductNameBox
                            hideBadge
                            data={oneItem}
                            searchString={searchString}
                        />
                    </a>
                ) : (
                    ''
                )}
                {oneItem.sku ? (
                    <div className={styles.statusCtr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText('product-table.sku')}
                        </h6>
                        <div className={styles.date}>{oneItem.sku}</div>
                    </div>
                ) : (
                    ''
                )}
            </div>
            <div className={styles.attrCtr}>
                {oneItem.partner_sku_unique ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText('offer.p-sku-unique')}
                        </h6>
                        <div className={styles.attrVal}>
                            {oneItem.partner_sku_unique}
                        </div>
                    </div>
                ) : (
                    ''
                )}
                {oneItem.qty ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText('variants.qty')}
                        </h6>
                        <div className={styles.attrVal}>{oneItem.qty}</div>
                    </div>
                ) : (
                    ''
                )}
            </div>
        </div>
    );
    return (
        <div className={styles.ctr}>
            <div className={styles.itemCtr}>
                <div className={styles.flexer}>
                    {item.title ? (
                        <a
                            target="_blank"
                            href={`${Helper.getAppDomain(
                                'catalog',
                            )}/${Helper.getLocale()}/catalog/${
                                item.psku_canonical
                            }`}
                        >
                            <ProductNameBox
                                hideBadge
                                data={item}
                                searchString={searchString}
                            />
                        </a>
                    ) : (
                        ''
                    )}
                </div>
            </div>
            <div className={styles.attrCtr}>
                {item.reason_code ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText('transfers.rejected-reason')}
                        </h6>
                        <div className={styles.attrVal}>{item.reason_code}</div>
                    </div>
                ) : (
                    ''
                )}
                {item.barcode_box ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText('inventory-rejection.box-barcode')}
                        </h6>
                        <div className={styles.attrVal}>{item.barcode_box}</div>
                    </div>
                ) : (
                    ''
                )}
                {item.warehouse_code ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText('offer.warehouse-code')}
                        </h6>
                        <div className={styles.attrVal}>
                            {item.warehouse_code}
                        </div>
                    </div>
                ) : (
                    ''
                )}
                {item.area_code ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText('stocks.area-code')}
                        </h6>
                        <div className={styles.attrVal}>{item.area_code}</div>
                    </div>
                ) : (
                    ''
                )}
                {item.zone_class ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText('stocks.zone-class')}
                        </h6>
                        <div className={styles.attrVal}>{item.zone_class}</div>
                    </div>
                ) : (
                    ''
                )}
                {item.sku ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText('product-table.sku')}
                        </h6>
                        <div className={styles.attrVal}>{item.sku}</div>
                    </div>
                ) : (
                    ''
                )}
                {item.partner_sku_unique ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText('offer.p-sku-unique')}
                        </h6>
                        <div className={styles.attrVal}>
                            {item.partner_sku_unique}
                        </div>
                    </div>
                ) : (
                    ''
                )}
                {item.returns_qty ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText(
                                'inventory-rejection.returns',
                                {},
                                'Returns',
                            )}
                        </h6>
                        <div className={styles.attrVal}>
                            {item.returns_qty || 0}
                        </div>
                    </div>
                ) : (
                    ''
                )}
                {item.created_at ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText(
                                'inventory-stocks.created-at',
                                {},
                                'Created at',
                            )}
                        </h6>
                        <div className={styles.attrVal}>{item.created_at}</div>
                    </div>
                ) : (
                    ''
                )}
                {item.qty_rejected ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText('inventory-stocks.rejected')}
                        </h6>
                        <div className={styles.attrVal}>
                            {item.qty_rejected || 0}
                        </div>
                    </div>
                ) : (
                    ''
                )}
                {item.qty_damaged ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText(
                                'inventory-stocks.damage',
                                {},
                                'Damage',
                            )}
                        </h6>
                        <div className={styles.attrVal}>{item.qty_damaged}</div>
                    </div>
                ) : (
                    ''
                )}
                {item.qty_allocated ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText('inventory-stocks.allocated-qty')}
                        </h6>
                        <div className={styles.attrVal}>
                            {item.qty_allocated || 0}
                        </div>
                    </div>
                ) : (
                    ''
                )}
                {item.qty_soh ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText('variants.qty')}
                        </h6>
                        <div className={styles.attrVal}>
                            {item.qty_soh || 0}
                        </div>
                    </div>
                ) : (
                    ''
                )}
                {item.pending_shipment ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText(
                                'inventory-rstocks.pending-shipment',
                                {},
                                'Pending Shipment',
                            )}
                        </h6>
                        <div className={styles.attrVal}>
                            {item.pending_shipment}
                        </div>
                    </div>
                ) : (
                    ''
                )}
                {item.other_qty ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText(
                                'inventory-stocks.others',
                                {},
                                'Others',
                            )}
                        </h6>
                        <div className={styles.attrVal}>
                            {item.other_qty || 0}
                        </div>
                    </div>
                ) : (
                    ''
                )}
                {item.qty_total ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText(
                                'inventory-stocks.total',
                                {},
                                'Total',
                            )}
                        </h6>
                        <div className={styles.attrVal}>
                            {item.qty_total || 0}
                        </div>
                    </div>
                ) : (
                    ''
                )}
                {item.qty ? (
                    <div className={styles.eachAttr}>
                        <h6 className={styles.attrTitle}>
                            {I18n.getText('variants.qty')}
                        </h6>
                        <div className={styles.attrVal}>{item.qty}</div>
                    </div>
                ) : (
                    ''
                )}
            </div>
        </div>
    );
};

export default StockBox;



// WEBPACK FOOTER //
// ./src/components/inventory/stockBox/StockBox.js